import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import CommonMultiForm from 'components/commonMultiForm/CommonMultiForm';

function PaymentHistory(props) {
  const navigate = useNavigate()

  const handleClose = () => {
    navigate('/payment');
  }
 
  return (
    <div className="commonBorder p20 br10 mt30">
      <Grid container className="justifyBetween">
        <Grid item>
          <Typography
            component={'h1'}
            fontSize={'18px'}
            className="titleStyle fw600 "
          >
            {props?.paymentName}
          </Typography>
        </Grid>
      </Grid>
      <CommonMultiForm
        formData={props?.formData}
        defaultValues={props?.defaultValues}
        disabled={props?.disabled}
        paymentBtn={props.button}
        onSubmittBtn={props.onSubmittBtn}
        payment={'payment'}
        formType={'payment'}
        formName={'dashboardData'}
        brnClass={''}
        handleClose={handleClose}
        radioSelected={props?.radioSelected}
      />
    </div>
  );
}

export default PaymentHistory;
